<template>
    <!-- <iframe :src="path[process.env.VUE_APP_NAME][$route.params.type]" frameborder="0" scrolling='auto'/> -->
    <iframe :src="pageLink" frameborder="0" scrolling='auto'/>
</template>

<script>
export default {
    name: "myIframe",
    data() {
        return {
            pageLink: '',
            path: {
                'shanghai-pudong': {
                    admissions: {
                        link: "https://dulwichpudong.openapply.cn/roi?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                    contact: {
                        link: "https://dulwichpudong.openapply.cn/roi?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                    scheduleavisit: {
                        // link: "https://dulwichpudong.openapply.cn/apply/forms/22426?frame=true",
                        link: "",
                        en: 'https://shanghai-pudong.dulwich.org/admissions/book-a-tour',
                        zh: 'https://shanghai-pudong.dulwich.org/zh/admissions/book-a-tour',
                        isDistinguish: true,
                        newPage: true,
                    },
                    apply: {
                        link: "https://dulwichpudong.openapply.cn/apply/forms/19795?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    }
                },
                'shanghai-puxi': {
                    admissions: {
                        link: "https://shanghai-puxi.dulwich.org/contact",
                        isDistinguish: false,
                        newPage: true,
                    },
                    contact: {
                        link: "https://shanghai-puxi.dulwich.org/contact",
                        isDistinguish: false,
                        newPage: true,
                    },
                    scheduleavisit: {
                        link: "https://dulwichpuxi.openapply.cn/tours/new?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                    apply: {
                        link: "https://dulwichpuxi.openapply.cn/apply/forms/19787?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    }
                },
                'high-school-suzhou': {
                    admissions: {
                        link: "",
                        en: "https://suzhou-high-school.dulwich.org/contact",
                        zh: "https://suzhou-high-school.dulwich.org/zh/contact",
                        isDistinguish: true,
                        newPage: true,
                    },
                    contact: {
                        link: "",
                        en: "https://suzhou-high-school.dulwich.org/contact",
                        zh: "https://suzhou-high-school.dulwich.org/zh/contact",
                        isDistinguish: true,
                        newPage: true,
                    },
                    scheduleavisit: {
                        // link: "http://dchigh-suzhou.mikecrm.com/fkJKEyh",
                        link: "https://dhsz.mike-x.com/M7mmg",
                        isDistinguish: false,
                        newPage: true,
                    },
                    apply: {
                        link: "",
                        en: "http://www.dchigh-suzhou.cn/en/applying-to-dulwich/application-form.htm",
                        zh: "http://www.dchigh-suzhou.cn/cn/applying-to-dulwich/application-form.htm",
                        isDistinguish: true,
                        newPage: true,
                    }
                },
                'suzhou': {
                    admissions: {
                        link: "",
                        en: "https://suzhou.dulwich.org/contact",
                        zh: "https://suzhou.dulwich.org/zh/contact",
                        isDistinguish: true,
                        newPage: true,
                    },
                    contact: {
                        link: "",
                        en: "https://suzhou.dulwich.org/contact",
                        zh: "https://suzhou.dulwich.org/zh/contact",
                        isDistinguish: true,
                        newPage: true,
                    },
                    scheduleavisit: {
                        link: "https://dulwichsuzhou.openapply.cn/tours/new?only=tours&frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                    apply: {
                        link: "https://dulwichsuzhou.openapply.cn/apply?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                },
                "singapore": {
                    admissions: {
                        link: "https://dcsg.openapply.com/roi?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                    contact: {
                        link: "https://singapore.dulwich.org/contact",
                        isDistinguish: false,
                        newPage: true,
                    },
                    scheduleavisit: {
                        // link: "https://dcsg.openapply.com/tours/new?only=tours&frame=true",
                        link: "https://singapore.dulwich.org/admissions/visit-us",
                        isDistinguish: false,
                        newPage: true,
                    },
                    apply: {
                        link: "https://dcsg.openapply.com/apply/forms/15040?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                },
                "high-school-hengqin": {
                    admissions: {
                        link: "",
                        en: "https://hengqin-high-school.dulwich.org/admissions",
                        zh: "https://hengqin-high-school.dulwich.org/zh/admissions",
                        isDistinguish: true,
                        newPage: true,
                    },
                    contact: {
                        link: "",
                        en: "https://hengqin-high-school.dulwich.org/contact",
                        zh: "https://hengqin-high-school.dulwich.org/zh/contact",
                        isDistinguish: true,
                        newPage: true,
                    },
                    scheduleavisit: {
                        link: "https://dulwichzhuhai.mike-x.com/l6kX7",
                        isDistinguish: false,
                        newPage: false,
                    },
                    apply: {
                        link: "https://dulwichzhuhai.mike-x.com/zVFgO",
                        isDistinguish: false,
                        newPage: false,
                    },
                },
                "seoul": {
                    admissions: {
                        link: "https://seoul.dulwich.org/admissions",
                        isDistinguish: false,
                        newPage: true,
                    },
                    contact: {
                        link: "https://seoul.dulwich.org/contact",
                        isDistinguish: false,
                        newPage: true,
                    },
                    scheduleavisit: {
                        link: "https://seoul.dulwich.org/admissions",
                        isDistinguish: false,
                        newPage: true,
                    },
                    // apply: {
                    //     link: "https://seoul.dulwich.org/admissions",
                    //     isDistinguish: false,
                    //     newPage: true,
                    // },
                    apply: {
                        link: "https://dulwichseoul.openapply.com/roi?frame=true&c_campaign=814",
                        isDistinguish: false,
                        newPage: false,
                    }
                },
                "beijing": {
                    admissions: {
                        link: "https://dulwichbeijing.openapply.cn/roi?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                    contact: {
                        link: "",
                        en: "https://beijing.dulwich.org/contact",
                        zh: "https://beijing.dulwich.org/zh/contact",
                        isDistinguish: true,
                        newPage: true,
                    },
                    scheduleavisit: {
                        link: "",
                        en: "https://beijing.dulwich.org/open-day",
                        zh: "https://beijing.dulwich.org/zh/open-day",
                        isDistinguish: true,
                        newPage: true,
                    },
                    apply: {
                        link: "https://dulwichbeijing.openapply.cn/apply/forms/19779?frame=true",
                        isDistinguish: false,
                        newPage: false,
                    },
                }
            },
        };
    },
    computed: {
        
    },
    components: {
        
    },
    mounted() {
        // console.log(this.$i18n.locale)
        this.getLink();
    },
    watch: {
        '$i18n.locale': 'getLink'
    },
    methods: {
        getLink(){
            let linkData = this.path[process.env.VUE_APP_NAME][this.$route.params.type];
            // console.log(linkData)
            let link = '';
            // 是否分中英文
            if(!linkData.isDistinguish){
                link = linkData.link;
            }else{
                if(this.$i18n.locale == 'en'){
                    link = linkData.en
                }else if(this.$i18n.locale == 'zh'){
                    link = linkData.zh
                }
            }
            // 是否是跳转链接
            if(linkData.newPage){
                window.location.href = link;
            }else{
                this.pageLink = link;
            }
        }
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
</style>